import { CustomDragLayer } from '@/shared/components/CustomDragLayer/CustomDragLayer'
import { HTML5toTouch } from 'rdndmb-html5-to-touch'
import React from 'react'
import { DndProvider } from 'react-dnd'
import { MultiBackend } from 'react-dnd-multi-backend'

export type GlobalDragDropProviderProps = {
  children: React.ReactNode
}

export const GlobalDragDropProvider: React.FC<GlobalDragDropProviderProps> = ({ children }) => {
  return (
    <DndProvider
      backend={MultiBackend}
      options={HTML5toTouch}
    >
      <CustomDragLayer />
      {children}
    </DndProvider>
  )
}

